module.exports = __webpack_public_path__ + "img/2-1.2e341934.svg";